import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'

axios.defaults.headers.post['Content-Type'] = 'application/json'
Vue.use(Vuex)
Vue.use(VueAxios, axios)

const backendUrl = 'https://musichenko.com/backend/api/'
const categoriesUrl = `${backendUrl}categories/`
const customersUrl = `${backendUrl}customers/`
const productsUrl = `${backendUrl}products/`
const ordersUrl = `${backendUrl}orders/`
const UsersUrl = `${backendUrl}users/`

export const store = new Vuex.Store({
  state: {
    productCategories: [],
    productsList: [],
    hasToken: null
  },
  mutations: {
    setProductCategories (state, categories) {
      state.productCategories = categories.data
    },
    setProductsList (state, proudcts) {
      state.productsList = proudcts.data
    },
    tokenWasChanged (state, to) {
      state.hasToken = to
    }
  },
  actions: {
    // categories api
    loadProductCategories (context) {
      axios.get(`${categoriesUrl}list.php`)
        .then(r => r.data)
        .then(categories => {
          context.commit('setProductCategories', categories)
        })
    },
    // products api
    loadProductsList (context) {
      return new Promise((resolve, reject) => {
        axios.get(`${productsUrl}list.php`)
          .then((products) => {
            if (products.data) {
              context.commit('setProductsList', products.data.products)
              resolve(products.data.products)
            } else {
              context.commit('setProductsList', [])
              resolve([])
            }
          }, error => {
            reject(error.response)
          })
      })
    },
    getProductById (context, id) {
      return new Promise((resolve, reject) => {
        axios.get(`${productsUrl}product_by_id.php?id=${id}`)
          .then((products) => {
            resolve(products.data)
          }, error => {
            reject(error.response)
          })
      })
    },
    editProductById (context, data) {
      const url = `${productsUrl}edit.php`
      return new Promise((resolve, reject) => {
        axios.put(url, data)
          .then((responce) => {
            resolve(responce)
          }, error => {
            reject(error.message)
          })
      })
    },
    // customers api
    saveCustomerFeedback (context, data) {
      const url = `${customersUrl}create.php`
      return new Promise((resolve, reject) => {
        axios.post(url, data)
          .then((responce) => {
            resolve(responce)
          }, error => {
            reject(error.response)
          })
      })
    },
    // orders api
    makeOrder (context, data) {
      const url = `${ordersUrl}create.php`
      return new Promise((resolve, reject) => {
        axios.post(url, data)
          .then((responce) => {
            resolve(responce.data)
          }, error => {
            reject(error)
          })
      })
    },
    // users api
    loginUser (context, data) {
      const url = `${UsersUrl}login.php`
      return new Promise((resolve, reject) => {
        axios.post(url, data)
          .then((responce) => {
            resolve(responce.data)
          }, error => {
            reject(error.message)
          })
      })
    },
    verifyUser (context, data) {
      const url = `${backendUrl}validate_token.php`
      return new Promise((resolve, reject) => {
        axios.post(url, data)
          .then((responce) => {
            resolve(responce.data.data)
          }, error => {
            reject(error.message)
          })
      })
    }
  },
  getters: {
    getProductsList (state) {
      return state.productsList
    },
    getProductCategories (state) {
      return state.productCategories
    }
  }
})
